import * as React from "react"
import {Box, Chip} from "@mui/material";
import {ImageSeeker} from "@ui-seeker/core";

import {useProxiedImage} from "../../../@hooks";


export default function MatcherSkuImageComparisonModalContainer({ url, fullURL, label, labelColor = 'primary' }) {
	const { imageResourceURL } = useProxiedImage(url)
	const __url = fullURL || imageResourceURL

	return <Box
		flex={1}
		minWidth={{ xs: 1, md: 0 }}
		border='1px solid'
		borderColor='divider'
		borderRadius={1}
		p={1}
		display="flex"
		alignItems="center"
		justifyContent="center"
		height={1}
		overflow="hidden"
		bgcolor='background.default'
		sx={{
			position: 'relative',
			'&:hover .zoomable': {
				transform: 'scale(1.2)',
			},
		}}
	>
		<Box position="absolute" top={8} left={8} zIndex={1}>
			{!!label && <Chip size="small" label={label} color={labelColor} sx={{ height: 22 }} />}
		</Box>

		<Box sx={{ width: 1, height: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
			<ImageSeeker
				useSpinner
				lazyLoad={false}
				src={__url}
				sx={{
					width: 1,
					height: 1,
					objectFit: 'contain',
					transition: 'transform .2s ease',
					willChange: 'transform',
					cursor: 'zoom-in',
				}}
				className="zoomable"
			/>
		</Box>
	</Box>
}